import { forwardRef, useContext } from 'react';

import { Button, Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { Menu, Version } from 'components';
import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { isSandbox, SANDBOX_REGISTRATION_URL } from 'sandbox';

import { ChatWidget } from './ChatWidget';
import { NavBarProps } from './interfaces';
import s from './NavBar.module.scss';

export const NavBar = forwardRef<HTMLElement, NavBarProps>(
  ({ isOpen }, ref) => {
    const { t } = useContext(LocalizationContext);

    return (
      <nav
        ref={ref}
        className={cn(s.container, isOpen && s.open)}
        data-onboarding="main-navigation"
      >
        <Menu />
        <div className={s['bottom-content']}>
          <FeatureHOC alias="tech_chat">
            <ChatWidget />
          </FeatureHOC>
          {isSandbox ? (
            <div
              className={s['registration-cta']}
              data-testid="sandbox-registration-cta"
            >
              <Button
                className={s['registration-button']}
                type="button"
                size="l"
                variant="primary"
                color="blue"
                fullWidth
                onClick={() =>
                  window.open(
                    SANDBOX_REGISTRATION_URL,
                    '_blank',
                    'noopener,noreferrer'
                  )
                }
              >
                {t('sandbox.registrationCta')}
              </Button>
              <Separator />
            </div>
          ) : (
            <Separator />
          )}
          <Version />
        </div>
      </nav>
    );
  }
);
